//@ts-ignore
import * as $ from 'jquery';
//@ts-ignore
window.$ = $;
//@ts-ignore
window.jQuery = $;
